import React, { ReactNode } from "react";
import { Box } from "@mui/material";

type Offset = "none" | "medium" | string;

type FullHeightProps = {
  verticalOffset?: Offset;
  children?: ReactNode;
};

const getOffset = (value: Offset): string => {
  switch (value) {
    case "none":
      return "0px";

    case "medium":
      return "84px";

    default:
      return value;
  }
};

const FullHeight = ({ verticalOffset = "none", children }: FullHeightProps) => {
  return (
    <Box sx={{ height: `calc(100% - ${getOffset(verticalOffset)})` }}>
      {children}
    </Box>
  );
};

export default FullHeight;